<template>
    <div name="advertisement-recv" class="component">
        <strong>(선택) 광고성 정보 수신</strong><br/><br/>
        <table class="table" style="width: 100%;">
            <thead>                
                <th style="width: 100%; text-align: center">내용</th>
            </thead>
            <tbody>
                <tr style="text-align: center">
                    <td>솔닥 서비스 관련 소식, 이벤트 안내 등 다양한 정보를 전화, 문자, 카카오톡, 이메일, SNS, 로 제공</td>
                </tr>
            </tbody>
        </table>
        <br>
        ※	광고성 정보 수신을 거부하실 수 있으며, 거부하시는 경우에도 솔닥 서비스를 이용하실 수 있으나, 솔닥의 각종 소식 수신 및 이벤트 참여에 제한이 있을 수 있습니다.<br/><br/>
        ※	광고성 정보 수신을 원하지 않으실 경우 [메뉴명]에서 철회를 요청하실 수 있습니다. 또한 향후 정보 수신을 새로이 동의하고자 하시는 경우 [메뉴명]에서 동의하실 수 있습니다.<br/><br/>

    </div>
</template>

<script>
export default {
    name: 'advertisementRecv'
}
</script>

<style scoped>
    .component{
        padding: 20px;
        padding-top: 40px;
        background: #FFFFFF;
    }
</style>


// WEBPACK FOOTER //
// src/pages/partners/contents/advertisement/20230314.vue